import React from 'react';
import styled from 'styled-components';
import NavComponent from '../navbar';
import HeroContent from './hero-content/HeroContent';
import { useExternalMedia } from "../../hooks/useExternalMedia";









const Hero = () => {
  const { hero_dey } = useExternalMedia();
  return (
    <Section

      style={{
        backgroundImage: `url(${hero_dey})`
      }}

    >
      <section
        id="hero"
        className="section hero-section">
        <NavComponent
        />
        <HeroContent />
      </section>

      {/* For smooth scrolling */}
      <div id="about"></div>
    </Section>
  )
}

export default Hero;




const Section = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background-color: #e2e2e2;
	background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;